
type PlaceholderMode = "toComputed" | "toToken";

type NormalizeOptions = {
	mode: PlaceholderMode;
	year?: number;
};

const YEAR_TOKEN_PATTERN = /\$\{c_(?:yyyy|year)\}/gi;
const CANONICAL_YEAR_TOKEN = "${c_yyyy}";
const ESCAPED_CANONICAL_YEAR_TOKEN = CANONICAL_YEAR_TOKEN.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
const COPYRIGHT_WITH_YEAR_PATTERN = new RegExp(
	`(©|&copy;)\\s*(?:\\d{4}|${ESCAPED_CANONICAL_YEAR_TOKEN})`,
	"gi",
);

export function normalizeHtmlPlaceholders(
	html: string,
	{
		mode,
		year = new Date().getFullYear(),
	}: NormalizeOptions,
): string {
	if (!html) return html;

	const yearText = String(year);

	if (mode === "toToken") {
		// Normalize to a single copyright token format and remove brand suffix.
		return html
			.replace(YEAR_TOKEN_PATTERN, CANONICAL_YEAR_TOKEN)
			.replace(COPYRIGHT_WITH_YEAR_PATTERN, `$1 ${CANONICAL_YEAR_TOKEN}`);
	}

	// toComputed: normalize token or hardcoded year to a static year and remove brand suffix.
	let output = html.replace(YEAR_TOKEN_PATTERN, yearText);
	output = output.replace(COPYRIGHT_WITH_YEAR_PATTERN, `$1 ${yearText}`);

	return output;
}